
import { Injectable} from '@angular/core';
import { DataProvider,ParameterService,Widget,DashboardConfigManager,AuthService,LogService,PieResponseObject } from "core-dashboard";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Subscription,timer } from "rxjs";


@Injectable()
export class DesigoccEventCountersProvider implements DataProvider {

    widget: Widget;
    config: any;
    eventCountersUrl = '/api/eventcounters';
    totalCount = 'TotalCount';
    unprocessedCount = 'UnprocessedCount';
    widgetDrawn: boolean = false;
    private timer;
    private subscription: Subscription;
    defaultinterval: number = 30;

    constructor(private authService: AuthService,
        private parameterService: ParameterService,
        private http: HttpClient,
        private loggerHelper: LogService,
        private dashboardConfig: DashboardConfigManager) {
    }
    //this is to get reduced COV data if required
    getReducedCovData(tData:any){

    }
    getData(w: Widget) {

        this.widget = w;
        this.config = this.widget.getConfig();
        try {

            if (this.config == undefined) {
                this.loggerHelper.logWarning("DesigoccEventCountersProvider", " Config is missing in widget setup.");
                this.widget.Draw(null);
                return;
            }

            if (this.authService.HasValidSSO() && this.authService.HasValidToken() === false) {
                this.authService.LoginWithSSO().subscribe(
                    (response:HttpResponse<any>) => {
                        if (response) {
                            this.GetEventCounters();
                        }
                    }, error => {
                        //this code will get executed when base URL path is inccorrect
                        this.loggerHelper.logWarning("DesigoccEventCountersProvider", "DesigoccEventCountersProvider is not able to login!");
                        this.widget.Draw(null);
                    });
            }
            else if (this.authService.HasValidToken()) {
                this.GetEventCounters();
            } else {
                this.loggerHelper.logWarning("DesigoccEventCountersProvider", "DesigoccEventCountersProvider is not able to login!");
                this.widget.Draw(null);
            }
        }
        catch (error) {
            this.loggerHelper.logError('DesigoccEventCountersProvider', "Error while fetching data. Error:" + error);
            this.widget.Draw(null);
        }
    }

     // this will zoom the widget
     zoom(zoomFrom: any, zoomTo: any) {       
    }

    private StartTimer(widget: Widget) {
        let interval = 1;
        if (this.config.pollingInterval != undefined)
            interval = this.config.pollingInterval;
        else
            interval = this.defaultinterval;

        var timerintervale = interval * 1000;
        this.timer = timer(timerintervale, timerintervale);
        this.subscription = this.timer.subscribe((t:HttpResponse<any>) => this.callback(widget));
    }

    callback(widget: Widget) {
        this.getData(widget);
    }


    private GetEventCounters() {
        let baseUrl = this.dashboardConfig.getBaseUrl();
        let url: string = baseUrl + this.eventCountersUrl;
        let counterType = this.config.counterType;

        //get token
        let token: any = this.authService.getToken();// window.sessionStorage.getItem("_token");
        let headers: HttpHeaders = new HttpHeaders({"Accept": "application/json","Access-Control-Allow-Origin": "*","Authorization": "Bearer " + token});
        // headers.append("Accept", "application/json");
        // headers.append("Access-Control-Allow-Origin", "*");
        // headers.append("Authorization", "Bearer " + token);
        this.loggerHelper.logInfo("DesigoccEventCountersProvider", "Calling WSI API");
        this.http.get(url, {headers}).subscribe((res:HttpResponse<any>) => {
            try {
                this.loggerHelper.logInfo("DesigoccEventCountersProvider", "Response received from service : " + res);
                if (res.status < 200 || res.status >= 300) {
                    throw new Error("Bad response status: " + res.status);
                }
                let body: any = res;//.json();
                //create data collection
                if (body && body.EventCategoryCounters) {
                    let data: any = [];
                    for (var i = 0; i < body.EventCategoryCounters.length; i++) // event counter's array 
                    {
                        let obj: any = body.EventCategoryCounters[i];
                        if (obj) {
                            let y: any;
                            let x: any = obj.CategoryDescriptor;// event type

                            if (counterType == this.totalCount)// counts (Total events)
                                y = obj.TotalCount;
                            else if (counterType == this.unprocessedCount) // count (unprocessed events)
                                y = obj.UnprocessedCount;
                            else
                                y = 0;

                            if (x !== undefined && y !== undefined)
                                data.push({ key: x, value: y });
                        }
                    }
                    this.loggerHelper.logInfo("DesigoccEventCountersProvider", "Call for drawing widget is initiated");
                    let piedata: PieResponseObject =
                        {
                            PropertyName: counterType,
                            ResponseArrayCollection: [data]
                        };

                    if (!this.widgetDrawn) {
                        this.widget.Draw(piedata);
                        this.widgetDrawn = true;
                        this.StartTimer(this.widget);
                    }
                    else
                        this.widget.Update(piedata)
                }
            }
            catch (error) {
                this.loggerHelper.logError('DesigoccEventCountersProvider', "Error while processing response for counterType " + counterType + "Error: " + error);
            }
        }, (error) => {
            //TODO:
            // this section of code was part of processError() method
            //because widget and loggerhelper are losing their references , moving code to inline method
            //this needs more investigation and code refactor
            let errMsg: any = (error && error.message) ? error.message : "Server error";
            if (this.loggerHelper)
                this.loggerHelper.logError("DesigoccEventCountersProvider", "Error in received from service: " + errMsg);
            if (this.widget)
                this.widget.Draw(null);
        });
    }

    private processError(error: any) {

    }

    public ngOnDestroy(): void {
        this.dispose();
    }


    dispose(): void {
        try {
            if (this.subscription)
                this.subscription.unsubscribe();
            if (this.loggerHelper)
                this.loggerHelper.logInfo("DesigoccEventCountersProvider", "DesigoccEventCountersProvider disposed");
        }
        catch (error) {
            if (this.loggerHelper)
                this.loggerHelper.logError("DesigoccEventCountersProvider", "error while dispoing dataprovider, " + error);
        }

    }
}